module.exports = __webpack_public_path__ + "img/lachstempuramakicloseup.b8092447.jpg";